import { MandalaMotif } from "@/components/MotifBackground";
import { imgSrc } from "@/lib/images";
import { useLang } from "@/context/LanguageContext";

// Visual section hero: traditional line-art backdrop on parchment with a soft fade,
// a subtle mandala flourish and a language-aware title pair. In English the English
// title is primary (large) and the Devanagari is the smaller secondary line; in
// Hindi/other scripts the Devanagari leads and the localized line is secondary.
export function PageHero({ art, overline, deva, en, tagline, children, align = "left" }) {
  const { isDeva } = useLang();
  const primary = isDeva ? deva : (en || deva);
  const secondary = isDeva ? en : (en ? deva : "");
  const primaryFont = isDeva ? "font-deva deva-lh" : "font-serif-latin";
  const secondaryFont = isDeva ? "font-serif-latin" : "font-deva deva-lh";

  return (
    <section className="relative border-b border-line bg-[var(--surface)]">
      <div className={`relative z-[2] mx-auto max-w-7xl px-5 py-14 md:px-8 md:py-20 ${align === "center" ? "text-center" : ""}`}>
        {overline && <p className="overline-label mb-3 text-gold">{overline}</p>}
        {primary && <h1 className={`${primaryFont} text-4xl leading-tight text-ink md:text-6xl`} data-testid="page-hero-title">{primary}</h1>}
        {secondary && secondary !== primary && <p className={`mt-3 ${secondaryFont} text-xl text-ink-2 md:text-2xl`}>{secondary}</p>}
        {tagline && <p className={`mt-5 max-w-2xl text-base leading-relaxed text-ink-2 md:text-lg ${align === "center" ? "mx-auto" : ""}`}>{tagline}</p>}
        {children}
      </div>
    </section>
  );
}
